import Vue from 'vue';

Vue.component('fuel-index', () =>
    import(/* webpackChunkName: 'fuel-index' */ './fuel-index.vue'),
);

Vue.component('fuel-index-v2', () =>
    import(/* webpackChunkName: 'fuel-index-v2' */ './fuel-index-v2.vue'),
);

Vue.component('fuel-create', () =>
    import(/* webpackChunkName: 'fuel-create' */ './fuel-create.vue'),
);

Vue.component('fuel-datatable', () =>
    import(/* webpackChunkName: 'fuel-datatable' */ './fuel-datatable.vue'),
);

Vue.component('dipping-index', () =>
    import(/* webpackChunkName: 'dipping-index' */ './dipping/dipping-index.vue'),
);

Vue.component('receiving-index', () =>
    import(/* webpackChunkName: 'receiving-index' */ './receiving/receiving-index.vue'),
);

Vue.component('site-acknowledgement', () =>
    import(/* webpackChunkName: 'site-acknowledgement' */ './price/site-acknowledgement.vue'),
);

Vue.component('daily-reconciliation', () =>
    import(/* webpackChunkName: 'daily-reconciliation' */ './daily-reconciliation/daily-reconciliation.vue'),
);

Vue.component('daily-reconciliation-report', () =>
    import(/* webpackChunkName: 'daily-reconciliation-report' */ './daily-reconciliation/daily-reconciliation-report.vue'),
);
